// import React from 'react';

const AppFooter = () => {
    return (
        <footer className="main-footer">
            <div className="container">
                <div>
                    לתמיכה טכנית צרו איתנו קשר{" "}
                    <a
                        href="https://www.jerusalem.muni.il/he/contactus/inquiry?formtype=132"
                        target="_blank"
                    >
                        בפנייה דיגיטלית
                    </a>{" "}
                    או בטלפון 02-6295488 בימים א'-ה' בין 08:30-16:00
                </div>
                <small className="google-disclaimer">
                    This site is protected by reCAPTCHA and the Google{" "}
                    <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
                    <a href="https://policies.google.com/terms">Terms of Service</a>{" "}
                    apply.
                </small>
            </div>
        </footer>
    )
}

export default AppFooter